import { FormViewProps } from "@/components/form/FormView"
import { MRT_ColumnDef } from "mantine-react-table"
import { Template } from "@/stores/template.store"
import StaticLayout from "@/components/layout/StaticLayout"
import TemplateGridItem from "./Template.grid"

interface TemplatesProps extends FormViewProps<any> {}

export const blankTemplate: Template = {
  id: "blank" as any,
  name: "Blank Scenario",
  workspace_id: "system" as any,
  created_at: "",
  updated_at: "",
  description: "Create a blank scenario",
  image_src: "",
  categories: ["basic"],
  long_description: "",
  initialValues: {
    name: "Scenario",
    nodes: [],
  },
}
export function Templates(props: TemplatesProps) {
  const columns: MRT_ColumnDef<Template>[] = [
    {
      header: "Name",
      accessorKey: "name",
    },
  ]

  return (
    <StaticLayout<Template>
      title="Set up your scenario"
      entityLabel="Template"
      description="Use our ready-to-use templates or start from scratch."
      routePath="/scenarios/create"
      storeName="template"
      bottomHeaderClassName="hidden"
      layout="center-big"
      GridComponent={TemplateGridItem}
      truncateGridCount={7}
      gridBefore={
        <TemplateGridItem
          item={blankTemplate}
          icon={
            <div className="rounded-full bg-card-hover fc mt-1 size-9 text-secondary">
              <IconMaterialSymbolsAdd className="size-6" />
            </div>
          }
        />
      }
      searchProps={{
        placeholder: "Search templates",
      }}
      columns={columns}
    />
  )
}
